<template>
  <div class="vs-sidebar--item">
    <a style="cursor: pointer;" @click="logout">
      <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />
      <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />
      <slot />
    </a>
  </div>
</template>

<script>
export default {
    methods: {
        logout () {
          this.$vs.loading()
          if(this.$store.state.auth.isUserLoggedIn()) {
            this.$store.dispatch('auth/logoutSanctum')
              .then()
              .catch(e => {})
              .finally(() => {
                this.$router.push('/pages/login').catch(() => {})
                this.$vs.loading.close()
              })
          } else {
            this.$router.push('/pages/login').catch(() => {})
            this.$vs.loading.close()
          }
        }
    },
  props: {
    icon        : { type: String,                 default: ''               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    featherIcon : { type: Boolean,                default: true             },
  },
}
</script>

<style>

</style>
